export default __webpack_public_path__ + "static/media/Banners_coche_enero800_330x330.7cfa1e40.jpg";